import { installTranslateDomGuard } from "./utils/google-translate-dom-fix";
// IMPORTANT: must run before ReactDOM.render so the patched removeChild/
// insertBefore are in place before React's first reconciliation. Prevents the
// "Oups" ErrorBoundary crash when the visitor's browser auto-translates the page.
installTranslateDomGuard();

import { initSentry } from "./sentry";
// IMPORTANT: initSentry() must run before any React rendering so that
// the ErrorBoundary and BrowserTracing integrations can capture early errors.
initSentry();

import { startVersionCheck } from "./utils/version-check";
// Auto-reload stale tabs after a new deploy (no-op if REACT_APP_BUILD_ID is unset).
startVersionCheck();

import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import "./icons.scss";
import App from "./pages/index";
import * as serviceWorker from "./serviceWorker";
ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
